
import { MutationTree } from 'vuex'
import { ReportsState } from '@/store/modules/report/types'

export enum ReportMutations {
  SET_REPORTS = 'SET_REPORTS',
  TRIGGER_LOADING = 'TRIGGER_LOADING',
  SET_SUBSCRIBER_REPORTS= 'SET_SUBSCRIBER_REPORTS',
  SELECT_REPORT = 'SELECT_REPORT',
  SET_INITIAL_REPORT = 'SET_INITIAL_REPORT',
  REMOVE_ACTION = 'REMOVE_ACTION'
}

export const mutations: MutationTree<ReportsState> = {
  [ReportMutations.SET_REPORTS] (state, payload) {
    state.reports = payload
  },

  [ReportMutations.TRIGGER_LOADING] (state, bool: boolean) {
    state.loading = bool
  },

  [ReportMutations.SET_SUBSCRIBER_REPORTS] (state, payload) {
    state.subscriberReport = payload
  },
  setCustomerId (state, payload) {
    state.customerId = payload ?? ''
  },
  setIndex (state, payload = 0) {
    state.currentIndex = payload
    state.selectedReport = state.reports[payload]
  },
  [ReportMutations.SELECT_REPORT] (state, index) {
    state.currentIndex = index
    state.selectedReport = state.reports[index]
  },

  [ReportMutations.SET_INITIAL_REPORT] (state, report) {
    state.selectedReport = report
  },
  [ReportMutations.REMOVE_ACTION] (state, { index, reportIndex }) {
    // const report = state.reports[reportIndex]
    state.reports[reportIndex].meta.actions = state.reports[reportIndex].meta.actions.filter((el: any, i) => i !== index)
  }
}
